import { createContext, useContext, type ReactNode } from 'react'
import {
  useWebPushSubscription,
  type WebPushSubscriptionState,
} from '../../hooks/useWebPushSubscription'

type WebPushSubscriptionContextValue = {
  state: WebPushSubscriptionState
  enablePush: () => Promise<void>
  disablePush: () => Promise<void>
}

const WebPushSubscriptionContext = createContext<WebPushSubscriptionContextValue | null>(null)

export function WebPushSubscriptionProvider({ children }: { children?: ReactNode }) {
  const value = useWebPushSubscription()

  return (
    <WebPushSubscriptionContext.Provider value={value}>
      {children}
    </WebPushSubscriptionContext.Provider>
  )
}

export function useWebPushSubscriptionContext(): WebPushSubscriptionContextValue {
  const context = useContext(WebPushSubscriptionContext)
  if (!context) {
    throw new Error('useWebPushSubscriptionContext must be used within WebPushSubscriptionProvider')
  }
  return context
}

export type { WebPushSubscriptionState }
